export const appToken = process.env.REACT_APP_APP_TOKEN
